/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { RoleMapping } from '@modules/cloud-api/v1/types'
import { isOrgOwnerRoleAssignments } from '@modules/role-assignments-lib'

import { validateOrgOwner } from '../CreateOrEditRoleMapping/RoleMappingBody/lib'

export const checkHasToRunValidation = ({
  roleMappings,
  selectedRoleMapping,
  organizationId,
}: {
  roleMappings: RoleMapping[]
  selectedRoleMapping: RoleMapping | undefined
  organizationId: string
}): boolean => {
  if (selectedRoleMapping) {
    return (
      isOrgOwnerRoleAssignments({
        roleAssignments: selectedRoleMapping.role_assignments,
        organizationId,
      }) &&
      roleMappings.length > 1 &&
      validateOrgOwner({
        roleMappings,
        originalRoleMapping: selectedRoleMapping ?? undefined,
        newRoleAssignments: selectedRoleMapping.role_assignments,
        newEnabledState: false,
        organizationId,
      }) !== 'CANNOT_DISABLE_ORG_OWNER_LAST_MAPPING' &&
      selectedRoleMapping.enabled
    )
  }

  return false
}

export const sorting = {
  sort: {
    field: 'name',
    direction: 'asc',
  } as const,
}
